import React, { useState, useRef } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from 'react-autocomplete';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const LoadingWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  right: '10px',
  zIndex: 9999, // Adjust the z-index as needed
});

function AddressInput() {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const autocompleteRef = useRef(null);
  let debounceTimeout;


  const handleMenuVisibility = (isOpen) => {
    // Prevent autoscrolling if the menu is hidden
    if (!isOpen && autocompleteRef.current) {
      try {
        autocompleteRef.current.handleMenuVisibility(false);
      } catch (error) {
        console.error('Error during autoscrolling:', error);
      }
    }
  };

  const handleInputChange = async (value) => {
    setInputValue(value);
    setError(null);

    // Clear previous debounce timeout
    clearTimeout(debounceTimeout);

    // Set a new debounce timeout
    debounceTimeout = setTimeout(async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${value}`);
        if (!response.ok) {
          throw new Error('Failed to fetch');
        }
        const data = await response.json();
        const formattedOptions = data.map(option => ({ label: option.display_name, value: option.display_name }));
        setOptions(formattedOptions);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setError('Failed to fetch suggestions. Please try again.');
        setLoading(false);
      }
    }, 500); // Adjust debounce delay as needed
  };

  return (
    <Autocomplete
      ref={autocompleteRef}
      value={inputValue}
      getItemValue={(item) => item.label}
      items={options}
      renderItem={(item, isHighlighted) => (
        <Typography
          key={item.value}
          variant="caption" // You can adjust the variant as needed
          style={{ background: isHighlighted ? '#e8e8e8' : 'transparent', display:'block', whiteSpace:'nowrap', padding: '8px 12px', cursor: 'pointer' }}
        >
          {item.label}
        </Typography>
      )}
      renderInput={(props) => (
        <div style={{ position: 'relative' }}>
          <input
            {...props}
            placeholder="Enter address..."
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: '1px solid #ced4da',
              fontSize: '16px',
            }}
            onChange={(e) => handleInputChange(e.target.value)}
          />
          {loading && (
            <LoadingWrapper>
              <CircularProgress color="inherit" size={20} />
            </LoadingWrapper>
          )}
        </div>
      )}
      onSelect={(value) => setInputValue(value)}
      menuStyle={{
        borderRadius: '3px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        background: 'rgba(255, 255, 255, 1)',
        lineHeight:'30px',
        position: 'fixed',
        overflow: 'hidden',
        maxHeight: '50%',
        zIndex:'100000',
        cursor:'pointer'
       }} // Adjust the z-index as needed
       onMenuVisibilityChange={handleMenuVisibility}
    />
  );
}

export default AddressInput;
